// This file is generated.
export var version = '1.72.1';
//# sourceMappingURL=version.js.map